import { useContext, useEffect, useState, useCallback } from "react";
import { Context } from "../Provider";
import { checkFtmCertificates, fetchDocumentTypes } from "../service";
import { theme } from "../../theme";
import DivSpinner from "../../common/DivSpinner";
import BtnSpinner from "../../common/BtnSpinner";
import FileAndUploader from "./uploadedCertificates/certificates/FileAndUploader";
import CardTemplate from "../../common/CardTemplate";
import useIsMobile from "../../common/hooks/useIsMobile";

const UploadedCertificates = () => {
    const { state, updateCurrentStep } = useContext(Context);
    const { ftm, step } = state;

    const [openFileUploadModal, setOpenFileUploadModal] = useState(false);
    const [selectedDocumentType, setSelectedDocumentType] = useState(null);
    const [loadingNext, setLoadingNext] = useState(false);
    const [refreshCounter, setRefreshCounter] = useState(0);

    const [documentTypes, setDocumentTypes] = useState([]);
    const [loadingDocs, setLoadingDocs] = useState(true);

    const isMobile = useIsMobile();

    const handleRefresh = () => setRefreshCounter((prev) => prev + 1);

    const fetchData = useCallback(async () => {
        setLoadingDocs(true);
        try {
            const response = await fetchDocumentTypes(ftm?.ftm_id);
            setDocumentTypes(response?.status === "Success" ? response.document_types || [] : []);
        } catch (error) {
            console.error("Error getting document types:", error);
            setDocumentTypes([]);
        } finally {
            setLoadingDocs(false);
        }
    }, [ftm?.ftm_id]);

    useEffect(() => {
        if (step.stepId > 5) {
            fetchData();
        }
    }, [fetchData, step, refreshCounter]);

    const handleOpenFileUploadModal = (docType) => {
        setSelectedDocumentType(docType);
        setOpenFileUploadModal(true);
    };

    const handleCloseFileUploadModal = () => setOpenFileUploadModal(false);

    const handleNext = async () => {
        setLoadingNext(true);
        try {
            const response = await checkFtmCertificates(ftm?.ftm_id);
            if (response?.status === "Success") {
                updateCurrentStep(7);
            }
        } catch (error) {
            console.error("Error moving to next step:", error);
        } finally {
            setLoadingNext(false);
        }
    };

    const handleNextItem = (id) => {
        const index = documentTypes.findIndex(item => item.documents_types_id === id);
        if (index !== -1 && index < documentTypes.length - 1) {
            setSelectedDocumentType(documentTypes[index + 1]);
        }
    };

    const handlePrevItem = (id) => {
        const index = documentTypes.findIndex(item => item.documents_types_id === id);
        if (index > 0) {
            setSelectedDocumentType(documentTypes[index - 1]);
        }
    };

    const LoadingComponent = () => (
        <div style={{ height: `${window.innerHeight - 387}px` }}>
            <DivSpinner />
        </div>
    );

    return (
        <CardTemplate
            stepId={7}
            currentStep={step?.stepId}
            // extraButtonComponet={
            //     <>
            //         {step.stepId === 6 && (
            //             <button
            //                 className={`btn btn-${theme.main} btn-sm`}
            //                 onClick={handleNext}
            //                 disabled={loadingNext}
            //             >
            //                 {loadingNext ? <BtnSpinner /> : "NEXT"}
            //             </button>
            //         )}
            //     </>
            // }
            body={
                <>
                    {loadingDocs ? (
                        <LoadingComponent />
                    ) : (
                        <>
                            <ul className="list-group">
                                {documentTypes.map((docType) => (
                                    <li
                                        key={docType.document_id}
                                        className="list-group-item list-group-item-action border-0 d-flex justify-content-between border-radius-0-2 cursor-pointer"
                                        onClick={() => handleOpenFileUploadModal(docType)}
                                    >
                                        <div className="d-flex flex-column">
                                            <h6 className="mb-1 text-dark font-weight-bold text-lg">
                                                {docType.documents_types_name}
                                                {docType.documents_types_is_required === 1 && (
                                                    <i className={`material-icons opacity-10 ms-2 text-danger text-xxs`}>
                                                        emergency
                                                    </i>
                                                )}
                                            </h6>
                                            <span className="text-xs">
                                                {docType?.skill?.skill_name}
                                                {docType?.skill?.sub_skill && ` (${docType.skill.sub_skill.sub_skill_name})`}
                                            </span>
                                        </div>
                                        <div className="d-flex align-items-center text-sm">
                                            {docType.have_documents ? (
                                                <>
                                                    <i className={`material-icons opacity-10 ms-2`}>
                                                        info
                                                    </i>
                                                    <i className={`material-icons opacity-10 text-${theme.main} ms-2`}>
                                                        check_circle
                                                    </i>
                                                </>
                                            ) : (
                                                <i className={`material-icons opacity-10 ms-2`}>
                                                    add_circle
                                                </i>
                                            )}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                            {step.stepId === 6 && (
                                <div className="mt-3 text-end">
                                    <button
                                        className={`btn btn-${theme.main} btn-sm ${isMobile && 'w-100'}`}
                                        onClick={handleNext}
                                        disabled={loadingNext}
                                    >
                                        {loadingNext ? <BtnSpinner /> : "NEXT"}
                                    </button>
                                </div>
                            )}
                        </>
                    )}

                    <FileAndUploader
                        ftm_id={ftm?.ftm_id}
                        item={selectedDocumentType}
                        items={documentTypes}
                        show={openFileUploadModal}
                        handleClose={handleCloseFileUploadModal}
                        type="certificates"
                        parentRefresh={handleRefresh}
                        handleNextItem={handleNextItem}
                        handlePrevItem={handlePrevItem}
                    />
                </>
            }
        />
    );
};

export default UploadedCertificates;